import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
    dashboard: {
        backgroundColor: theme.colors.black,
        height: '100%',
        display: 'flex',
        alignItems: 'stretch',
        padding: 16,
        marginLeft: 80,
        overflow: 'hidden',
    },
    sidebar: {
        width: 80,
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100%',
        backgroundColor: '#232b3a',
        padding: '46px 0',
    },
    title: {
        fontFamily: theme.typographyPresets.fonts.monserrat.bold,
        fontSize: '28px',
        fontWeight: '800',
        color: theme.colors.white,
    },
    logo: {
        margin: '0 auto',
        display: 'block',
        width: 36,
    },
    left: { flex: 1, marginRight: 16 },
    right: {
        flex: '0 0 350px',
    },
    widget: {
        borderRadius: 20,
        border: 'solid 1px',
        borderColor: theme.colors.dark.dark3,
        backgroundImage: `linear-gradient(to bottom, ${theme.colors.dark.dark3}, ${theme.colors.black})`,
        padding: 20,
        minHeight: 100,
        width: '100%',
        marginBottom: 16,
        color: 'white',
    },
    widgetContainer: {
        columns: 2,
    },
    widgetTitle: {
        fontFamily: theme.typographyPresets.fonts.monserrat.regular,
        fontSize: '14px',
        fontWeight: '600',
        textAlign: 'center',
        color: '#5c6676',
    },
    textLeft: {
        textAlign: 'left',
    },
    count: {
        margin: 0,
        fontFamily: 'NotoSans',
        fontSize: '34px',
        color: 'white',
        textAlign: 'center',
    },
}))
